<template>
	<div class="login">
		<div class="loginbox">
			<div class="title u-flex u-row-between">
				<span>注册</span>
				<span style="color:#51BA85;font-size:20px;font-weight: 400;" @click="backlogin">返回登录</span>
			</div>
			<div style="margin-top: 51px;">
				<el-input placeholder="请输入手机号码" v-model="phone">
					<template slot="prepend">+86</template>
				</el-input>
			</div>
			<div class="u-flex u-col-center" style="margin-top: 20px;">
				<el-input placeholder="请输入手机验证码" v-model="ver_code" style="margin-right:20px">
				</el-input>
				<el-button style="width: 210px;" @click="send">{{text}}</el-button>
			</div>
			<el-input placeholder="请输入用户名" v-model="username" style="margin-top: 20px;"> </el-input>

			<el-input placeholder="请输入密码" v-model="password" show-password style="margin-top: 20px;"> </el-input>

			<div style="font-size:16px;color:#888888;margin-top: 26px;">
				<el-checkbox v-model="checked"></el-checkbox>注册即同意<span style="color:#51BA85;margin-left: 5px;">《用户服务协议》</span>
			</div>
			<el-button class="submit" type="success" @click="submit">注册</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				phone: '',
				password: '',
				ver_code: '',
				username: "",
				checked: false,
				s: 60,
				text: '获取短信验证码',
				time: null
			}
		},
		methods: {
			submit() {
				if (!/^1[3-9]\d{9}$/.test(this.phone)) {
					this.$message.error('请输入手机号');
					return
				}
				if (!this.ver_code) {
					this.$message.error('请输入验证码');
					return
				}
				if (!this.username) {
					this.$message.error('请输入用户名');
					return
				}
				if (!this.password) {
					this.$message.error('请输入密码');
					return
				}
				if (!this.checked) {
					this.$message.error('请同意用户服务协议');
					return
				}
				this.$http({
					url: "/api/Login/Register",
					data: {
						phone: this.phone,
						ver_code: this.ver_code,
						password: this.password,
						nickname: this.username
					}
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.backlogin()
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			send() {
				if (!/^1[3-9]\d{9}$/.test(this.phone)) {
					this.$message.error('请输入手机号');
					return
				}
				if (this.s == 60) {
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					setTimeout(() => {
						loading.close();
						this.s--
						this.time = setInterval(() => {
							this.text = `${this.s}s`
							this.s--
							if (this.s == -1) {
								this.text = '获取短信验证码'
								this.s = 60
								clearInterval(this.time)
							}
						}, 1000)
					}, 2000);
				} else {
					this.$message.error("请稍后再试")
				}
			},
			backlogin() {
				this.$router.push('/login')
			}
		}
	};
</script>

<style scoped>
	.submit {
		font-size: 20px;
		width: 400px;
		height: 60px;
		margin-top: 44px;
		background-color: #51BA85;
	}

	.forget {
		font-size: 14px;
		color: #51BA85;
		text-align: right;
		margin-top: 14px;
	}

	.el-input__inner {
		font-size: 18px;
	}

	.el-input {

		width: 400px;
		font-size: 18px;

	}

	.title {
		border-left: 6px solid #51ba85;
		padding-left: 8px;
		font-size: 36px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: #222222;
	}

	.login {
		position: relative;
		background: url(../assets/login/bg.png) no-repeat center center;
		background-size: 100% 100%;
		width: 100vw;
		height: 100vh;
	}

	.loginbox {
		width: 600px;
		height: 720px;
		padding: 80px 100px 0;
		box-sizing: border-box;
		position: absolute;
		right: 130px;
		top: 50%;
		transform: translateY(-50%);

		background: #ffffff;
		box-shadow: 0px 2px 20px 0px rgba(187, 210, 237, 0.2);
	}

	.register {
		font-size: 16px;
		color: #999999;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 600px;
		height: 80px;
		line-height: 80px;
		text-align: center;
		background: #f3f8ff;
	}
</style>
